export enum videoContainerType{
  fullScreen =  "full_screen",
  inline = "inline"
}
export const defaultVideoContatainerType = videoContainerType.fullScreen;
